import React from 'react'
import MaterialSymbol from '../material-symbol'

const Celebration = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="celebration" {...props} />
))

Celebration.displayName = 'Celebration'

export default Celebration
